<template>
    <div class="container-fluid">
        <!--Top-->

        <div class="row m-b-30">
            <div class="col-6">
                <h2 class="m-b-0">New Bill</h2>
            </div>
            <div class="col-6 text-right">
                <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true"
                            class="btn waves-effect waves-light btn-outline-success dropdown-toggle"
                            data-toggle="dropdown" type="button">
                        Action
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="javascript:void(0)">Export as PDF</a>
                        <a class="dropdown-item" href="javascript:void(0)">Print</a>
                        <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">Void</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Invoice Header-->

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <a aria-controls="collapseHeader" aria-expanded="false" class="btn" data-toggle="collapse"
                       href="#collapseHeader">
                        <div class="card-body text-left">
                            Business Address and Contact Info
                        </div>
                    </a>
                    <div class="collapse" id="collapseHeader">
                        <div class="card-body">
                            <div class="d-md-flex align-items-center">
                                <div>
                                    <h3>Bill</h3>
                                </div>
                                <div class="ml-auto">
                                    <div class="d-flex">
                                        <div class="m-r-20">
                                            <blockie :address="currentOrg.biz_email" :width="70"
                                                     v-if="!orgImg"></blockie>
                                            <img :src="orgImg" class="rounded-circle" height="100" v-if="orgImg"
                                                 width="100"/>
                                        </div>
                                        <address>
                                            <h3>{{currentOrg.name}}</h3>
                                            <p class="text-muted m-l-5">
                                                <i class="fas fa-phone"></i>&nbsp;{{currentOrg.biz_phone}}<br/>
                                                <i class="fas fa-envelope"></i>&nbsp;{{currentOrg.biz_email}}
                                            </p>
                                        </address>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Bill-->

        <div class="row">
            <div class="col-sm-12">
                <div class="card card-shadow">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <form class="form-horizontal">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <label class="text-left control-label col-form-label col-sm-3">Partner Type</label>
                                            <div class="col-sm-9 mt-2">
                                                <div class="form-check form-check-inline">
                                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                                           class="form-check-input"
                                                           data-vv-as="type"
                                                           id="Member"
                                                           name="type"
                                                           type="radio"
                                                           v-model="partner_type"
                                                           v-validate="'required'"
                                                           value="Member">
                                                    <label class="form-check-label" for="Member">Member</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                                           class="form-check-input"
                                                           data-vv-as="type"
                                                           id="Supplier"
                                                           name="type"
                                                           type="radio"
                                                           v-model="partner_type"
                                                           v-validate="'required'"
                                                           value="Supplier">
                                                    <label class="form-check-label" for="Supplier">Supplier</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row" v-if="partner_type === 'Member'">
                                            <label class="col-sm-3 text-left control-label col-form-label"
                                                   for="did">Bill To:</label>
                                            <div class="col-sm-9">
                                                <multiselect
                                                        :class="{'is-invalid': submitted && errors.has('member_id')}"
                                                        :clear-on-select="true"
                                                        :close-on-select="true"
                                                        :hide-selected="true"
                                                        :internal-search="true"
                                                        :limit="3"
                                                        :max-height="600"
                                                        :options="members"
                                                        :options-limit="300"
                                                        :searchable="true"
                                                        :show-no-results="false"
                                                        @search-change="searchMembers"
                                                        class="form-control"
                                                        data-vv-as="buyer"
                                                        id="did"
                                                        label="short_name"
                                                        name="member_id"
                                                        open-direction="bottom"
                                                        placeholder="Search Member"
                                                        track-by="did"
                                                        v-model="bill.member">
                                                    <template slot="singleLabel" slot-scope="props">
                                                        {{props.option.short_name}}
                                                    </template>
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                            <h5>{{ props.option.short_name }}</h5>
                                                            <div>{{ props.option.did | hex_format(10, '....') }}</div>
                                                        </div>
                                                    </template>
                                                </multiselect>
                                                <div class="invalid-feedback" v-if="submitted && errors.has('member_id')">{{
                                                    errors.first('member_id') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row" v-else-if="partner_type === 'Supplier'">
                                            <label class="col-sm-3 text-left control-label col-form-label">Bill
                                                To:</label>
                                            <div class="col-sm-9">
                                                <multiselect
                                                        :class="{'is-invalid': submitted && errors.has('partner')}"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :hide-selected="true"
                                                        :internal-search="false"
                                                        :limit="3"
                                                        :loading="isLoading"
                                                        :max-height="600"
                                                        :options="partners"
                                                        :options-limit="300"
                                                        :searchable="true"
                                                        :show-no-results="false"
                                                        @search-change="searchPartners"
                                                        class="form-control"
                                                        data-vv-as="partner"
                                                        id="partner"
                                                        label="partner"
                                                        name="partner"
                                                        open-direction="bottom"
                                                        placeholder="Search Partners"
                                                        track-by="id"
                                                        v-model="bill.partner"
                                                        v-validate="'required'">
                                                    <template slot="singleLabel" slot-scope="props">
                                                        <div class="option__desc">
                                                            <div class="option__desc">
                                                                {{ props.option.org_name }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc">
                                                            <div class="option__desc" v-if="props.option">
                                                                <h5>{{ props.option.org_name }}</h5>
                                                                <h6>{{ props.option.line1}}</h6>
                                                                <h6>{{ props.option.city+', '+
                                                                    props.option.country}}</h6>
                                                            </div>
                                                            <div class="option__desc" v-else>
                                                                <h5>Add New</h5>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-3 text-left control-label col-form-label">Currency:</label>
                                            <div class="col-sm-9">
                                                <div :class="{'is-invalid': submitted && errors.has('currency')}"
                                                     class="form-control p-0-0">
                                                    <currency-select @currency-select="setCurrency"
                                                                     data-vv-as="currency"
                                                                     ref="reference"
                                                                     v-model="bill.currency.id"
                                                                     v-validate="'required'">
                                                    </currency-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-3 text-left control-label col-form-label">Notes:</label>
                                            <div class="col-sm-9">
                                                <textarea :class="{'is-invalid': submitted && errors.has('notes')}"
                                                          class="form-control"
                                                          cols="30"
                                                          data-vv-as="notes"
                                                          id="notes"
                                                          name="notes"
                                                          v-model="bill.notes"
                                                          v-validate="''">
                                                </textarea>
                                                <div class="invalid-feedback" v-if="submitted && errors.has('notes')">{{
                                                    errors.first('notes') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-md-6">
                                <form class="form-horizontal">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <label class="col-sm-8 text-right control-label col-form-label">Bill
                                                Number:</label>
                                            <div class="col-sm-4">
                                                <input :class="{'is-invalid': submitted && errors.has('bill_number')}"
                                                       autocomplete="off"
                                                       class="form-control"
                                                       data-vv-as="invoice_number"
                                                       id="bill_number"
                                                       name="bill_number"
                                                       placeholder=""
                                                       style="height: 42px;"
                                                       type="text"
                                                       v-model="bill.bill_number">
                                                <div class="invalid-feedback"
                                                     v-if="submitted && errors.has('bill_number')">{{
                                                    errors.first('invoice_number') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-8 text-right control-label col-form-label">SO / PO
                                                Number:</label>
                                            <div class="col-sm-4">
                                                <input :class="{'is-invalid': submitted && errors.has('so_number')}"
                                                       autocomplete="off"
                                                       class="form-control"
                                                       data-vv-as="so_number"
                                                       id="so_number"
                                                       name="so_number"
                                                       placeholder=""
                                                       style="height: 42px;"
                                                       type="text"
                                                       v-model="bill.so_number">
                                                <div class="invalid-feedback"
                                                     v-if="submitted && errors.has('so_number')">{{
                                                    errors.first('so_number') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-8 text-right control-label col-form-label">Bill
                                                Date:</label>
                                            <div class="col-sm-4">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i
                                                                class="far fa-calendar-alt"></i></span>
                                                    </div>
                                                    <input :class="{'is-invalid': submitted && errors.has('creation_date')}"
                                                           autocomplete="off"
                                                           class="form-control"
                                                           data-vv-as="creation_date"
                                                           id="creation_date"
                                                           name="creation_date"
                                                           placeholder="mm/dd/yyyy"
                                                           style="height: 42px;"
                                                           type="text"
                                                           v-model="bill.issue_at"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('creation_date')">{{
                                                        errors.first('creation_date') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-8 text-right control-label col-form-label">Due
                                                Date:</label>
                                            <div class="col-sm-4">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i
                                                                class="far fa-calendar-alt"></i></span>
                                                    </div>
                                                    <input :class="{'is-invalid': submitted && errors.has('due_date')}"
                                                           autocomplete="off"
                                                           class="form-control"
                                                           data-vv-as="due_date"
                                                           id="due_date"
                                                           name="due_date"
                                                           placeholder="mm/dd/yyyy"
                                                           style="height: 42px;"
                                                           type="text"
                                                           v-model="bill.due_at"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('due_date')">{{
                                                        errors.first('due_date') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table v-middle invoice">
                            <thead>
                            <tr class="bg-light">
                                <th class="border-top-0"></th>
                                <th class="border-top-0" colspan="2">Goods &amp; Services</th>
                                <th class="border-top-0">Expense Category</th>
                                <th class="border-top-0">Quantity</th>
                                <th class="border-top-0">Rate</th>
                                <th class="border-top-0 text-right amount-col">Amount</th>
                                <th class="border-top-0"></th>
                            </tr>
                            </thead>

                            <bill-line-item
                                    :currency="bill.currency"
                                    :marketplaceid="currentOrg.marketplace_id"
                                    :index="index"
                                    :key="item.id"
                                    :lineitem="item"
                                    :events="events"
                                    v-for="(item, index) in bill.items"
                            >
                            </bill-line-item>

                            <tbody>
                            <tr>
                                <td class="text-center" colspan="7">
                                    <button data-target="#searchAndSelectCommodityModal" data-toggle="modal" class="btn waves-effect waves-light btn-outline-info"
                                            type="button">
                                        <i class="fas fa-plus"></i> Add Goods/Services
                                    </button>
                                </td>
                            </tr>
                            </tbody>

                            <tbody class="total">
                            <tr>
                                <td class="text-right no-border" colspan="6">
                                    <h5>Total</h5>
                                </td>
                                <td class="no-border text-right">
                                    <h5>{{bill.currency.symbol}} {{total}}</h5>
                                </td>
                                <td class="no-border icon-col"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!--Bottom-->

        <div class="row m-t-30">
            <div class="col-6 m-b-30">
            </div>
            <div class="col-6 text-right">
                <div class="button-group">
                    <button @click="handleSubmit()" class="btn waves-effect waves-light btn-success" type="button">
                        Save
                    </button>
                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset
                    </button>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import Blockie from '../../common/Blockie';
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import CurrencySelect from "../../../protected/common/CurrencySelect";
    import BillLineItem from "./BillLineItem";
    import Vue from "vue";
    import SearchSelectCommodity from "../../common/SearchSelectCommodity";

    export default {
        name: "NewBill",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),

            total: function () {
                let total = 0;
                this.bill.items.forEach(item => {
                    let sub_total = 0;
                    let tax_total = 0;
                    item.taxes.forEach(tax => {
                        tax_total = Number(tax_total) + Number(tax.value.amount);
                    });

                    if (item.amount) {
                        sub_total = Number(item.amount.amount) + Number(tax_total);
                    }
                    total = Number(total) + Number(sub_total);

                });
                this.bill.total.amount = total;
                return total;
            }
        },
        components: {SearchSelectCommodity, Blockie, Multiselect, CurrencySelect, BillLineItem},
        data() {
            return {
                events: new Vue(),
                partner_type: null,
                expressid: '',
                isLoading: false,
                isLoadingGs: false,
                orgImg: null,
                partners: [],
                members: [],
                sales: [],
                submitted: false,
                bill: {
                    bill_number: null,
                    partner: null,
                    member: null,
                    issue_at: null,
                    due_at: null,
                    items: [],
                    total: {
                        amount: 0,
                        currency_id: null,
                        currency_name: null,
                        currency_symbol: null
                    },
                    currency: {
                        id: null,
                        name: null,
                        symbol: null
                    },
                    so_number: null,
                    notes: null
                },
                taxes: [],
                tax: {
                    index: null,
                    obj: null
                },
                taxRates: [],
                tax_rate: {
                    id: null,
                    value: null
                },
                adjst_types: ['DISCOUNT', 'ADJUSTMENT'],
                adjustment: {
                    index: null,
                    type: null,
                    value: null
                },
                commodityIds: []
            };
        },
        mounted() {
            this.init();
        },
        created() {
            this.events.$on('bill:removeitem', index => {
                this.removeRow(index);
            });
        },
        methods: {
            async init() {
                jQuery('#creation_date').datepicker({
                    constrainInput: true,
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.bill.issue_at = event.target.value;
                });

                jQuery('#due_date').datepicker({
                    constrainInput: true,
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.bill.due_at = event.target.value;
                });

                await this.getAttachment();
                await this.getBillNUmber();
            },
            async getAttachment() {
                let attachments = await this.$http.get(`/org/${this.currentOrg.id}/attachments`);
                if (attachments.data && attachments.data.length > 0) {
                    this.orgImg = `https://attachments-acrecx.s3.us-east-2.amazonaws.com/${attachments.data[0].filepath}`;
                }
            },
            async getBillNUmber() {
                let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/bills/suggest/number`);
                this.bill.bill_number = response.data.number;
            },
            async searchMembers(searchText) {
                let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                this.members = data.dids;
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            addRow() {
                this.bill.items.push({
                    goodsSerivces: {},
                    description: '',
                    rate: null,
                    unit: {
                        id: null,
                        symbol: null
                    },
                    amount: null,
                    quantity: null,
                    taxes: [],
                    subtotal: {
                        amount: null,
                        currency_id: null,
                        currency_name: null,
                        currency_symbol: null
                    }
                });
            },
            removeRow(index) {
                this.bill.items.splice(index, 1);
                this.commodityIds = this.bill.items.map(item=> item.goodsSerivces.id);
            },
            calculateTotal() {
                this.invoice.total = {
                    amount: 0,
                    currency_id: this.invoice.currency.id,
                    currency_name: this.invoice.currency.name,
                    currency_symbol: this.invoice.currency.symbol
                };
                this.bill.items.forEach(ini => {
                    this.invoice.total.amount = Number(this.invoice.total.amount) + Number(ini.subtotal.amount);
                })
            },
            setCurrency(e) {
                if (e) {
                    this.bill.currency.id = e.id;
                    this.bill.currency.name = e.name;
                    this.bill.currency.symbol = e.symbol;
                    this.bill.total = {
                        amount: null,
                        currency_id: this.bill.currency.id,
                        currency_name: this.bill.currency.name,
                        currency_symbol: this.bill.currency.symbol
                    }
                }
            },
            removeItem(i) {
                this.invoice.total = {
                    amount: null,
                    currency_id: null,
                    currency_name: null,
                    currency_symbol: null
                };
                this.bill.items.splice(i, 1);
            },
            async addTaxFromModal() {
                this.calculateTax(this.tax.index);
            },
            resetTax() {
                this.tax = {
                    index: null,
                    obj: null
                };
                this.tax_rate = {
                    id: null,
                    value: null
                }
            },
            removeTax(i, j) {
                if (this.bill.items[i].adjustments.length === 0 && this.bill.items[i].taxes.length === 1) {
                    this.bill.items[i].subtotal = {
                        amount: null,
                        currency_id: null,
                        currency_name: null,
                        currency_symbol: null
                    }
                } else {
                    this.bill.items[i].subtotal.amount = Number(this.bill.items[i].subtotal.amount) - Number(this.bill.items[i].taxes[j].value.amount);
                }
                this.invoice.total.amount = Number(this.invoice.total.amount) - Number(this.bill.items[i].taxes[j].value.amount);
                this.bill.items[i].taxes.splice(j, 1);
            },
            addAdjustment(index) {
                this.adjustment.index = index;
            },
            async addAdjustmentFromModal() {
                this.calculateAdjustment(this.adjustment.index);
            },
            calculateAdjustment(index) {
                this.bill.items[index].adjustments.push({
                    type: this.adjustment.type,
                    value: {
                        amount: this.adjustment.value,
                        currency_id: this.invoice.currency.id,
                        currency_name: this.invoice.currency.name,
                        currency_symbol: this.invoice.currency.symbol
                    }
                });
                this.calculateSubtotalForAdjustment(index);
            },
            calculateSubtotalForAdjustment(index) {
                let sub_amt;
                if (this.bill.items[index].adjustments.length === 1 && this.bill.items[index].taxes.length === 0) {
                    sub_amt = this.bill.items[index].amount.amount;
                } else {
                    sub_amt = this.bill.items[index].subtotal.amount;
                }
                this.bill.items[index].subtotal = {
                    amount: Number(sub_amt) - Number(this.adjustment.value),
                    currency_id: this.invoice.currency.id,
                    currency_name: this.invoice.currency.name,
                    currency_symbol: this.invoice.currency.symbol
                };
                this.invoice.total.amount = Number(this.invoice.total.amount) - Number(this.adjustment.value);
                this.calculateTotal();
                this.resetAdjustment();
            },
            resetAdjustment() {
                this.adjustment = {
                    index: null,
                    type: null,
                    value: null
                };
            },
            removeAdjustment(i, j) {
                if (this.bill.items[i].adjustments.length === 1 && this.bill.items[i].taxes.length === 0) {
                    this.bill.items[i].subtotal = {
                        amount: null,
                        currency_id: null,
                        currency_name: null,
                        currency_symbol: null
                    }
                } else {
                    this.bill.items[i].subtotal.amount = Number(this.bill.items[i].subtotal.amount) + Number(this.bill.items[i].adjustments[j].value.amount);
                }
                this.invoice.total.amount = Number(this.invoice.total.amount) + Number(this.bill.items[i].adjustments[j].value.amount);
                this.bill.items[i].adjustments.splice(j, 1);
            },
            async handleSubmit() {
                this.submitted = true;
                this.events.$emit('bill_line_item:validate');
                this.$validator.validate()
                    .then((valid) => {
                        if (valid) {
                            this.save();
                        }
                    })
            },
            async save() {
                try {
                    let reply = await this.$http.put("/marketplaces/" + this.currentOrg.marketplace_id + "/bills", this.bill);
                    // this.reset();
                    this.$toastr('success', 'Bill added', 'Success');
                    await this.$router.push({name: "view-marketplace-bill", params: {billid: reply.data.billid}});
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            },
            reset() {
                this.invoice = {
                    partner: null,
                    issue_at: null,
                    due_at: null,
                    items: [],
                    total: null,
                    currency: {
                        id: null,
                        name: null,
                        symbol: null
                    }
                }
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.bill.items.find(row=> row.goodsSerivces.commodity_id === c.id);
                    if(!found){
                        c['commodity_id'] = c.id;
                        this.bill.items.push({
                            id: c.id,
                            name: c.name,
                            variety: c.variety,
                            goodsSerivces: c,
                            description: '',
                            rate: c.rate? c.rate.amount : null,
                            unit: {
                                id: c.unit? c.unit.id : null,
                                name: c.unit? c.unit.name : null,
                                symbol: c.unit ? c.unit.symbol : null
                            },
                            amount: null,
                            quantity: null,
                            taxes: [],
                            subtotal: {
                                amount: null,
                                currency_id: null,
                                currency_name: null,
                                currency_symbol: null
                            }
                        });
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            },
        }
    }
</script>

<style scoped>
    table td {
        text-align: left;
    }

    table th {
        text-align: left;
    }

    .no-border {
        border-top: 0px;
    }


    .amount-col {
        width: 100px;
    }

    .icon-col {
        width: 25px;
    }

    table tbody.total {
        border-top: 0;
    }

</style>
